import FrameworkCourseController from "../../../framework-course.controller";

class Diagram1Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 5;
    this.exerciseId = 'exercise-1';
    this.clearDiagramId = 1
    this.first = true;
    this.pyramidData = {
      exerciseNumber: 1,
      scheme: {
        model: {
          textarea: 'Believe you would find it useful to participate in the pilot Risk Management Study',
        },
        children: [
          {
            model: {
              textarea: 'Will cover useful information',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Will produce a customized confidential report',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Will be updated periodically with analytical insights into developing credit risk trends.',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Will be subject to annual Steering Commit-tee review on utility/relevance of benchmarks',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Next steps – to enroll',
            },
            children: [

            ]
          },
        ],
      },
      scq: {
        's-header': 'DE, Sit',
        'c-header': 'R1, R2, Sol',
      },
    };
  }

}

export default Diagram1Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5d/diagram1/diagram1.controller.js